// ----------------------------------------------------------------------------
// Component: Timeline
// ----------------------------------------------------------------------------
//
// A list of timeline items
//
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import SwiperCore, { Swiper, Navigation, Pagination, Scrollbar, A11y, Keyboard } from 'swiper/core';
import 'snippets/icon/icon';

// Style includes
import 'swiper/swiper-bundle.css';
import './_timeline.scss';

// Install modules
SwiperCore.use([Swiper, Navigation, Pagination, Scrollbar, A11y, Keyboard]);

// -------------------------------------
// Variables
// -------------------------------------

// -------------------------------------
// Hooks
// -------------------------------------
function handleTimelineSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index, array) {
        slide.addEventListener('focus', function(e) {
            var slidePos = swiperEl.$el[0].getBoundingClientRect();

            // Remove standard scrolling to element in focus due to it going off the screen (slides left when it needs to stay on screen)
            swiperEl.$el[0].scrollLeft = 0;
            swiperEl.slideTo(index);

            // Emulating normal tab focus due to needing to remove standard scroll
            // If element is already in viewport, do nothing
            // Otherwise, scroll to the element and it should be in the middle of the screen when scrolling stops
            if (!(slidePos.top >=0 &&
            slidePos.left >=0 &&
            slidePos.bottom <= $(window).height() &&
            slidePos.right <= $(window).width())) {
                window.scrollTo({
                    top: (slidePos.top + window.scrollY) - ($(window).height() / 2),
                    left: 0,
                    behavior: 'smooth'
                });
            }

        })
    });
}

$(function() {
    $(".carousel--timeline").each(function(index, element){
        var $this = $(this);

        // Generate unique class for each timeline slider
        $this.addClass("timeline-instance-" + index);

        // Generate unique btn classes for slider arrows
        $this.parents('.timeline').find(".swiper-button-prev").addClass("timeline-btn-prev-" + index);
        $this.parents('.timeline').find(".swiper-button-next").addClass("timeline-btn-next-" + index);

        // Generate unique btn classes for swiper pagination
        $this.parents('.timeline').find(".swiper-pagination").addClass("timeline-swiper-pagination-" + index);

        // Initialize feature collection slider based on the unique classes generated above.
        var swiper = new Swiper(".timeline-instance-" + index, {
             // Optional parameters
            slidesPerView: 1,
            spaceBetween: 15,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true,
            autoHeight: true,

            // Navigation arrows
            navigation: {
              nextEl: ".timeline-btn-next-" + index,
              prevEl: ".timeline-btn-prev-" + index
            },

            pagination: {
                el: ".timeline-swiper-pagination-" + index,
                type: 'bullets',
                clickable: true,
            },
        });

        if (swiper.slides) {
            handleTimelineSlides(swiper);
        } else {
            swiper.forEach(function(swiperEl) {
                handleTimelineSlides(swiperEl);
            })
        }
    });
});
